import type { ReactNode } from "react";
import dgptLogo from "@/assets/dgptlogo.png";

/**
 * The /get-started frame: brand panel on the left, onboarding on the right.
 * /onboarding uses it too, so a user who signs up with Google lands in the
 * same place as one who signs up with email.
 */
export function OnboardingShell({ children }: { children: ReactNode }) {
  return (
    <div className="fixed inset-0 flex">
      <BrandPanel />
      <div className="relative h-dvh w-full lg:w-1/2">{children}</div>
    </div>
  );
}

function BrandPanel() {
  return (
    <div className="relative hidden overflow-hidden bg-zinc-950 text-white lg:flex lg:w-1/2">
      <div
        className="absolute inset-0 opacity-[0.04]"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32' width='32' height='32' fill='none' stroke='rgb(255 255 255 / 0.15)'%3e%3cpath d='M0 .5H31.5V32'/%3e%3c/svg%3e")`,
        }}
      />
      <div className="absolute -left-24 -top-24 h-96 w-96 rounded-full bg-blue-600/20 blur-3xl" />
      <div className="absolute bottom-0 right-0 h-80 w-80 rounded-full bg-indigo-600/15 blur-3xl" />

      <div className="relative flex w-full flex-col justify-between p-12">
        <div className="flex items-center">
          <img src={dgptLogo} alt="DiligenceGPT" className="h-9 w-auto" />
        </div>

        <div className="max-w-md space-y-6">
          <blockquote className="space-y-4">
            <p className="text-[2rem] font-bold leading-tight tracking-tight">
              Get started with
              <br />
              <span className="text-blue-400">DiligenceGPT.</span>
            </p>
            <p className="text-base leading-relaxed text-zinc-400">
              Streamline your deal evaluation with AI-driven insights, automated data
              gathering, and comprehensive startup analysis — all in one platform.
            </p>
          </blockquote>
        </div>

        <div className="flex items-center gap-2 text-xs text-zinc-500">
          <span>© {new Date().getFullYear()} StartupFuel Inc.</span>
          <span>·</span>
          <span>All rights reserved</span>
        </div>
      </div>
    </div>
  );
}
